import { Impact, Likelihood, Seriousness } from '../../restapi/types';

const likelihoodIndex = {
	[Likelihood.unspecified]: 0,
	[Likelihood.negligible]: 1,
	[Likelihood.low]: 2,
	[Likelihood.moderate]: 3,
	[Likelihood.high]: 4,
	[Likelihood.veryHigh]: 5,
};

const impactIndex = {
	[Impact.unspecified]: 0,
	[Impact.negligible]: 1,
	[Impact.low]: 2,
	[Impact.moderate]: 3,
	[Impact.high]: 4,
	[Impact.veryHigh]: 5,
};

const seriousnessMatrix = [
	[0, 0, 0, 0, 0, 0],
	[0, 1, 1, 2, 2, 2],
	[0, 1, 2, 2, 3, 3],
	[0, 2, 2, 3, 3, 4],
	[0, 2, 3, 3, 4, 4],
	[0, 2, 3, 4, 4, 5],
] as const;  // not any number but only 0..5

const seriousnessFromIndex = {
	0: Seriousness.unspecified,
	1: Seriousness.negligible,
	2: Seriousness.low,
	3: Seriousness.moderate,
	4: Seriousness.high,
	5: Seriousness.veryHigh,
};

export function computeSeriousness(l: Likelihood, i: Impact) {
	const li = likelihoodIndex[l];
	const ii = impactIndex[i];
	return seriousnessFromIndex[seriousnessMatrix[li][ii]];
}
